






























import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetListByCode } from "@/api/configureDictionary";
import { InsertEducationPlanStep,UpdateEducationPlanStep } from "@/api/pdEducationPlan/pdEducationPlan";
@Component({})
export default class PdEducationPlanStepAdd extends AbpBase {
  @Prop() pdEducationPlanStep: any;
  EducationPlanStep :any={}
  loading: boolean = false;
  rules = {
    title: [
      {
        required: true,
        type: "string",
        message: "步骤名称不能为空",
        trigger: "change"
      }
    ],
    description: [
      {
        required: true,
        type: "string",
        message: "步骤说明",
        trigger: "change"
      }
    ]
  };
  
  @Watch("pdEducationPlanStep", { immediate: false, deep: true })
  onGetEducationPlanStep() {
    if (this.pdEducationPlanStep) {
      this.EducationPlanStep = this.pdEducationPlanStep;
    }
  }

  resetForm() {
    this.$refs["form"].resetFields();
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.EducationPlanStep.id >0) {
        await UpdateEducationPlanStep(this.EducationPlanStep);
      } else {
        await InsertEducationPlanStep(this.EducationPlanStep);
      }
      return true;
    }
    return false;
  }
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdEducationPlan/parts/pdEducationPlan/pdEducationPlanStepAdd.vue